(() => {
  if (!customElements.get("up-press-reviews")) {
    class upPressReviews extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        const echoSlider = this.querySelector("echo-slider");
        const slider = echoSlider.querySelector(".swiper");

        const buttons = this.querySelectorAll(".press-logo");

        buttons.forEach((button) => {
          button.addEventListener("click", () => {
            const slideIndex = parseInt(
              button.getAttribute("data-slide-index")
            );

            buttons.forEach((btn) => {
              btn.classList.remove("_active");
            });

            button.classList.add("_active");
            slider.swiper.slideTo(slideIndex);
          });
        });
      }

      connectedCallback() {
        this.init();
      }
    }
    customElements.define("up-press-reviews", upPressReviews);
  }
})();
